// src/vocabulary/B1/unit1/content.js

const content = {
  level: "B1",
  unit: 1,
  title: "Travel & Transport",
  description:
    "Common travel situations and types of transport. Learn how to talk about trips, tickets, and moving around.",

  explanation: [
    "This unit focuses on travel and transportation.",
    "You will learn words used when traveling by bus, train, or plane.",
    "These words help you talk about trips, plans, and movement.",
    "In English, we often use these words with verbs like 'take', 'go', and 'travel'.",
    "For example: I take the bus to work. We travel by train.",
    "You can also use them to talk about tickets and stations.",
    "Travel vocabulary is very useful when visiting new places.",
    "Try to imagine a trip and describe how you move from one place to another."
  ],

  items: [
    {
      word: "bus",
      phonetic: "/bʌs/",
      meaning: "حافلة",
      example: "I take the bus to work."
    },
    {
      word: "train",
      phonetic: "/treɪn/",
      meaning: "قطار",
      example: "The train arrives at nine."
    },
    {
      word: "plane",
      phonetic: "/pleɪn/",
      meaning: "طائرة",
      example: "She travels by plane."
    },
    {
      word: "ticket",
      phonetic: "/ˈtɪkɪt/",
      meaning: "تذكرة",
      example: "I bought a train ticket."
    },
    {
      word: "station",
      phonetic: "/ˈsteɪʃən/",
      meaning: "محطة",
      example: "The bus station is near my house."
    },
    {
      word: "travel",
      phonetic: "/ˈtrævəl/",
      meaning: "يسافر",
      example: "They travel abroad every year."
    },
    {
      word: "trip",
      phonetic: "/trɪp/",
      meaning: "رحلة",
      example: "We had a great trip last summer."
    }
  ]
};

export default content;


